@if (editorContent()) {
	<lvr-heading [showEditButton]="false">
		{{ 'assignment.fds.template_title' | transloco }}
		<div ngProjectAs="button-content">
			@if (report()?.isFinal) {
				<lvr-button
					variant="primary"
					[label]="'base.button.export' | transloco"
					[ariaLabel]="'base.button.export_pdf' | transloco"
					[type]="'button'"
					[disabled]="!report()?.canBeSubmitted"
					(clicked)="export('report.pdf')"
					[loading]="isExporting()"
					[loadingLabel]="'base.button.export_pdf' | transloco"
					icon="ios_share"
				></lvr-button>
			}
		</div>
	</lvr-heading>
	<lvr-html-editor
		(docChange)="onTemplateChange($event)"
		[html]="renderContent()"
		[readOnly]="(report()?.isFinal ?? false) || !canEditReport()"
	></lvr-html-editor>
} @else {
	<p lvrPadding [padHorizontal]="32" [padVertical]="16" class="template-empty">-</p>
}
@if (!report()?.isFinal) {
	<lvr-default-actions
		[disableSave]="report()?.isFinal || !canEditReport()"
		(save)="save()"
		(cancelSave)="cancel()"
		[showLoading]="isSaving()"
	></lvr-default-actions>
}
